import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
): { totalPrescriptions: number; totalMedications: number } | null => {
  //   console.log(res.data);
  const newData = {
    totalPrescriptions: 0,
    totalMedications: 0,
  };
  if (Object.keys(res.data).length) {
    newData.totalMedications = res.data?.total_medications;
    newData.totalPrescriptions = res.data?.total_prescriptions;

    return newData;
  }

  return null;
};

export const useGetTotalPrescriptions = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.totalPrescriptionsWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get("analytics/prescriptions/counts", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            staff_id: userId,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Total prescriptions & medications]", res);
      handleErrors(res, "query");
    },
  });
};
